import {useZero} from '@/shared/integrations/zero/use-zero'
import {toaster} from '@cypro/ui/toaster'
import {ImportPatientFromHl7Schema} from '@cypro/engine/mutators'
import {useTranslate} from '@tolgee/react'
import {useCallback} from 'react'

export function useImportHl7Patient() {
  const {t} = useTranslate('common')
  const {t: tPatients} = useTranslate('patients')
  const zero = useZero()

  return useCallback(
    (payload: ImportPatientFromHl7Schema) =>
      zero.attemptMutation(zero.mutators.patients.importFromHl7(payload), async mutation => {
        const data = await mutation.server
        if (!data) return
        toaster.success({title: t('success'), description: tPatients('patient_imported_successfully')})
        return data
      }),
    [zero, t, tPatients]
  )
}
